// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","slogan":"header_slogan__QYJ7D","btns":"header_btns__z0wgq","btn_p":"header_btn_p__2pbBV","btn_t":"header_btn_t__2hrpE"};